<template>
  <div class="bg-white p-8 rounded-[16px] shadow-lg w-[520px] overflow-auto scrollbar max-h-full">
    <!-- Modal Header -->
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-[22px] font-semibold text-dark">{{ title }}</h2>
      <button @click="modal.rejectModal('cancel')" class="text-grey hover:text-dark">
        <img src="@/assets/icons/close.svg" alt="close" class="h-6 w-6" />
      </button>
    </div>
    <form @submit="onSubmit" class="space-y-4">
      <FormField v-slot="{ componentField }" name="name">
        <FormItem>
          <FormLabel>Название</FormLabel>
          <FormControl>
            <Input type="text" placeholder="Введите название" v-bind="componentField" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
      <FormField v-slot="{ componentField }" name="color">
        <FormItem>
          <FormLabel>Цвет</FormLabel>
          <FormControl>
            <Input type="color" placeholder="Выберите цвет" v-bind="componentField" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
      <FormField v-slot="{ componentField }" name="order">
        <FormItem>
          <FormLabel>Порядок</FormLabel>
          <FormControl>
            <Input type="number" placeholder="Введите порядок" v-bind="componentField" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
      <div class="flex justify-between  justify-end gap-4">
        <Button variant="destructive" type="button" :disabled="isDeleting" class="" @click="handleDeleteCategory">
          <Loader2 v-if="isDeleting" class="w-4 h-4 mr-2 animate-spin" />
          {{ isDeleting ? 'Удаление...' : 'Удалить' }}
        </Button>

        <Button type="submit" :disabled="isLoading" class="bg-primary h-full text-white font-medium rounded-[12px] text-[15px] hover:bg-[#40a9ff] transition-colors">
          <Loader2 v-if="isLoading" class="w-4 h-4 mr-2 animate-spin" />
          {{ isLoading ? 'Сохранение...' : 'Сохранить' }}
        </Button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, reactive, toRaw, computed } from 'vue'
import { useModalStore } from '@/store/modal'
import { useToast } from '@/components/ui/toast'
import { Input } from '@/components/ui/input'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-vue-next'
import {useForm, configure, defineRule} from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'
import {useSettingsStore} from '@/store/settings'
import { createCategory, updateCategory, deleteCategory } from '@/api/core'

const settingsStore = useSettingsStore()
const { toast } = useToast()
const modal = useModalStore()
const props = modal.modalProps
const isLoading = ref(false)
const isDeleting = ref(false)
const formSchema = toTypedSchema(z.object({
  name: z.string().min(2, 'Минимальная длина 2 символа').max(50, 'Максимальная длина 50 символов'),
  color: z.string().min(2, 'Минимальная длина 2 символа').max(50, 'Максимальная длина 50 символов'),
  order: z.number().min(0, 'Минимальное значение 0').max(100, 'Максимальное значение 100'),
}))

const form = useForm({
  validationSchema: formSchema,
  initialValues: {
    name: props.category?.name ?? '',
    color: props.category?.color ?? '#ffffff',
    order: props.category?.order ?? 0,
  },
})

const handleDeleteCategory = () => {
  isDeleting.value = true
  deleteCategory(props.category.id).then((response) => {
    console.log(response)
    if (response.status === 200 || response.status === 204) { 
      toast({
        title: 'Успешно',
        description: 'Категория удалена',
      })
      modal.resolveModal(true)
    } else {
      toast({
        title: 'Ошибка',
        description: response.data.message || 'Не удалось удалить категорию',
        variant: 'destructive',
      })
    }
    isDeleting.value = false
  }).catch((error) => {
    console.log(error)
    toast({
      title: 'Ошибка',
      description: 'Не удалось удалить категорию',
      variant: 'destructive',
    })
    isDeleting.value = false
  })
}

const title = computed(() => {
    if (props.category) {
        return 'Редактирование категории'
    } else if (props.parent_id) {
        return 'Создание подкатегории'
    } else {
        return 'Создание категории'
    }
})

const onSubmit = form.handleSubmit((values) => {
  isLoading.value = true
  console.log('Form submitted!', values, props.country_id, props.category?.parent_id ?? null)
  let data = {
    name: values.name,
    color: values.color.substring(1),
    sort_order: values.order,    
  }

  if(props.category) { //UPDATE
    // if (props.category) {
    //   data.id = props.category.id
    // }
    console.log('update',props)
    updateCategory(props.category.id, data).then((response) => {
      console.log(response)

      if (response.status === 200) { 
        toast({
          title: 'Успешно',
          description: 'Категория обновлена',
        })
        modal.resolveModal(true)
      } else {
        toast({
          title: 'Ошибка',
          description: response.data.message || 'Не удалось обновить категорию',
          variant: 'destructive',
        })
      }
      isLoading.value = false
    }).catch((error) => {
      console.log(error)
      toast({
        title: 'Ошибка',
        description: 'Не удалось обновить категорию',
        variant: 'destructive',
      })
      isLoading.value = false
    })
  } else { //CREATE

    if(props.parent_id) {
      data.parent_id = props.parent_id
    }

    data.country_id = props.country_id

    createCategory(data).then((response) => {
      console.log(response)

      if (response.status === 200 || response.status === 201) { 
        toast({
          title: 'Успешно',
          description: 'Категория создана',
        })
        modal.resolveModal(true)
      } else {
        toast({
          title: 'Ошибка',
          description: response.data.message || 'Не удалось создать категорию',
          variant: 'destructive',
        })
      }
      isLoading.value = false
    }).catch((error) => {
      console.log(error)
      toast({
        title: 'Ошибка',
        description: 'Не удалось создать категорию',
        variant: 'destructive',
      })
      isLoading.value = false
    })
  }

})



</script>

<style scoped>
/* Additional styling if needed */
</style>
